import { render, staticRenderFns } from "./RTL.vue?vue&type=template&id=2039174e&scoped=true&"
import script from "./RTL.vue?vue&type=script&lang=js&"
export * from "./RTL.vue?vue&type=script&lang=js&"
import style0 from "./RTL.vue?vue&type=style&index=0&id=2039174e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039174e",
  null
  
)

export default component.exports